// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FI59","right":"styles_right__1qjjw"};